import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import AuthStore from '../../stores/AuthStore'
import { Metrics } from '../../Themes'
import NavbarWrapper from './NavbarWrapper'

const Page = styled.div`
  height: calc(100vh - ${Metrics.components.navbarDefault});
  margin-top: -${Metrics.margins.tiny};
  overflow: hidden;
`

const Container = styled.section`height: 100vh;`

class Public extends Component {
  getInitialState () {
    return AuthStore.getState()
  }

  static getStores () {
    return [ AuthStore ]
  }

  static getPropsFromStores () {
    let authState = AuthStore.getState()
    return {
      user: authState.user,
      fetching: authState.fetching,
      hvbToken: authState.hvbToken,
      errorMessage: authState.errorMessage
    }
  }

  componentWillReceiveProps (nextProps, nextState) {
    if (this.props.user && !nextProps.user) {
      this.props.router.replace('/landing')
    }
  }

  render () {
    const { children, router, user } = this.props
    return (
      <Container>
        <NavbarWrapper user={user} router={router} />
        <Page>
          {children &&
            React.cloneElement(children, {
              user
            })}
        </Page>
      </Container>
    )
  }
}

Public.propTypes = {
  children: PropTypes.node,
  user: PropTypes.object,
  router: PropTypes.object
}

export default Public



// WEBPACK FOOTER //
// ./src/pages/Public/index.js